import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { SidebarRoutingModule } from './sidebar-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {SidebarModule} from "../../component/ing/sidebar/sidebar";
import {TableModule} from "../../component/ing/table/table";
import {ButtonModule} from "../../component/ing/button/button";

@NgModule({
  imports: [
    CommonModule,
    SidebarRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    SidebarModule,
    TableModule,
    ButtonModule
  ],
  declarations: [SidebarComponent]
})
export class SidebarDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/sidebar/sidebarDemo.module.ts